/**
 * Re-apply locally-typed key casing onto an API-returned variable list.
 * Backends may normalize keys (e.g. to lowercase); this prevents that from
 * overwriting what the user typed.
 */
export function restoreVarKeyCase(local, apiVars) {
  if (!Array.isArray(apiVars) || !Array.isArray(local)) return apiVars ?? local;
  return apiVars.map((apiVar) => {
    const match = local.find(
      (lv) => (lv.key ?? '').toLowerCase() === (apiVar.key ?? '').toLowerCase()
    );
    return match ? { ...apiVar, key: match.key } : apiVar;
  });
}
